var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTagGroupEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 97,
    viewBox: "0 0 99 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6663 95.7097C75.9924 95.7097 97.3423 74.5204 97.3423 48.3549C97.3423 22.1893 75.9924 1 49.6663 1C23.3402 1 1.99039 22.1893 1.99039 48.3549C1.99039 74.5204 23.3402 95.7097 49.6663 95.7097Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1867 42.1747V71.1494C86.1867 77.1691 81.2907 82.0651 75.1907 82.0651H24.3043C18.2846 82.0651 13.3886 77.2494 13.3083 71.2297C13.3083 71.1494 13.3083 71.1494 13.3083 71.0692V42.1747C13.3083 42.0944 13.3083 42.0944 13.3083 42.0141C13.3083 41.8536 13.3083 41.6931 13.3886 41.5326C13.4689 41.2918 13.5491 41.1312 13.6294 40.8905L27.274 14.8051C27.7556 13.7617 28.799 13.1999 29.9227 13.1999H69.4921C70.6158 13.1999 71.5789 13.7617 72.1408 14.8051L85.7854 40.8905C85.8657 41.051 85.9459 41.2918 86.0262 41.5326C86.1867 41.6931 86.1867 41.9339 86.1867 42.1747Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1804 42.4154H39.5529C38.6701 42.4154 37.9477 41.7733 37.9477 40.8101V12.638C37.9477 11.7551 38.5898 11.0327 39.5529 11.0327H60.1001C60.983 11.0327 61.7054 11.6748 61.7054 12.638V40.8101C61.7054 41.693 61.0633 42.4154 60.1804 42.4154Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0032 49.0775H32.7311C31.6074 49.0775 30.7245 48.1143 30.7245 47.0709V19.7014C30.7245 18.5777 31.6877 17.6948 32.7311 17.6948H67.0032C68.1269 17.6948 69.0098 18.658 69.0098 19.7014V47.0709C68.9295 48.1946 68.1269 49.0775 67.0032 49.0775Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9358 56.8626H28.8782C27.6743 56.8626 26.6309 55.8192 26.6309 54.6955V27.7273C26.6309 26.5233 27.6743 25.5602 28.8782 25.5602H70.9358C72.1397 25.5602 73.1831 26.6036 73.1831 27.7273V54.6152C73.1029 55.8994 72.1397 56.8626 70.9358 56.8626Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1897 64.4074H24.6243C23.2598 64.4074 22.2164 63.2837 22.2164 62.0798V35.5129C22.2164 34.1484 23.3401 33.1853 24.6243 33.1853H75.1897C76.5541 33.1853 77.5975 34.3089 77.5975 35.5129V61.9995C77.5173 63.364 76.5541 64.4074 75.1897 64.4074Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0197 43.6997H40.9975C40.5159 43.6997 40.0344 43.2984 40.0344 42.7365C40.0344 42.255 40.4357 41.7734 40.9975 41.7734H60.0197C60.5013 41.7734 60.9829 42.1747 60.9829 42.7365C60.9829 43.2984 60.5816 43.6997 60.0197 43.6997Z",
    fill: "#E6ECF5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4822 49.3181H30.4035C30.0824 49.3181 29.8416 49.0773 29.8416 48.7562C29.8416 48.4352 30.0824 48.1944 30.4035 48.1944H54.402C54.723 48.1944 54.9638 48.4352 54.9638 48.7562C55.1243 48.9168 54.8835 49.3181 54.4822 49.3181Z",
    fill: "#E6ECF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2937 49.3181H58.174C57.853 49.3181 57.6122 49.0773 57.6122 48.7562C57.6122 48.4352 57.853 48.1944 58.174 48.1944H70.2134C70.5344 48.1944 70.7752 48.4352 70.7752 48.7562C70.9358 48.9168 70.695 49.3181 70.2937 49.3181Z",
    fill: "#E6ECF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_1995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.9986 43.6274V71.098C81.9986 75.0051 78.873 78.1308 74.8948 78.1308H24.5997C20.6925 78.1308 17.4958 75.0051 17.4958 71.098V43.4853C17.4958 43.3432 17.4958 43.2012 17.5669 43.0591H31.3557C33.771 43.0591 35.7601 44.9771 35.7601 47.4635C35.7601 48.6711 36.2574 49.8077 37.0388 50.5891C37.8913 51.4416 38.8858 51.8678 40.1645 51.8678H60.2036C62.6189 51.8678 64.608 49.9498 64.608 47.4635C64.608 46.2558 65.1053 45.1192 65.8867 44.3378C66.7392 43.4853 67.7337 43.0591 68.9414 43.0591H81.8566C81.9986 43.2012 81.9986 43.4143 81.9986 43.6274Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1867 42.1746V74.119C86.1867 78.5335 82.6552 82.065 78.1605 82.065H21.3346C16.9201 82.065 13.3083 78.5335 13.3083 74.119V42.014C13.3083 41.8535 13.3083 41.693 13.3886 41.5325H31.6885C34.4174 41.5325 36.6647 43.6996 36.6647 46.5087C36.6647 47.8732 37.2266 49.1574 38.1095 50.0403C39.0726 51.0034 40.1963 51.485 41.641 51.485H57.9343C60.6632 51.485 62.9106 49.3179 62.9106 46.5087C62.9106 45.1443 63.4724 43.8601 64.3553 42.9772C65.3185 42.014 66.4421 41.5325 67.8066 41.5325H86.0262C86.1867 41.693 86.1867 41.9338 86.1867 42.1746Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.16 70.5073H61.6259C61.0641 70.5073 60.5825 70.106 60.5825 69.4639C60.5825 68.9021 60.9838 68.4205 61.6259 68.4205H77.9995C78.5613 68.4205 79.0429 68.8218 79.0429 69.4639C79.1232 69.9455 78.6416 70.5073 78.16 70.5073Z",
    fill: "#E6ECF5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7759 75.5639H61.6259C61.0641 75.5639 60.5825 75.1626 60.5825 74.5205C60.5825 73.9587 60.9838 73.4771 61.6259 73.4771H70.6956C71.2574 73.4771 71.739 73.8784 71.739 74.5205C71.8193 75.0021 71.3377 75.5639 70.7759 75.5639Z",
    fill: "#E6ECF5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0826 78.9349C64.7615 80.2994 64.2799 81.7441 63.7181 82.948C62.1931 85.9178 59.7852 88.2454 56.8155 89.7704C53.7656 91.2953 50.1537 91.9374 46.5419 91.1348C37.9538 89.2888 32.496 81.0217 34.2618 72.5139C36.0275 64.0061 44.2946 58.468 52.8024 60.314C55.8524 60.9561 58.501 62.4811 60.7484 64.5679C64.601 68.3403 66.126 73.7179 65.0826 78.9349Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6429 73.2798H52.0311V70.668C52.0311 69.4322 51.0596 68.3035 49.6666 68.3035C48.4309 68.3035 47.3022 69.275 47.3022 70.668V73.2798H44.6904C43.4546 73.2798 42.3259 74.2512 42.3259 75.6442C42.3259 76.2851 42.5543 76.8888 43 77.3346C43.4458 77.7803 44.0495 78.0087 44.6904 78.0087H47.3022V80.6205C47.3022 81.8563 48.2736 82.985 49.6666 82.985C50.9024 82.985 52.0311 82.0135 52.0311 80.6205V78.0087H54.6429C55.8787 78.0087 57.0074 77.0372 57.0074 75.6442C57.0074 74.2512 55.8787 73.2798 54.6429 73.2798Z",
    fill: "white",
    stroke: "#AAB2C5",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_1995",
    x: 4.49582,
    y: 27.0591,
    width: 90.5028,
    height: 61.0717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_1995"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_1995",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagGroupEmptyState);
export default __webpack_public_path__ + "static/media/TagGroupEmptyState.a48d179d515f25cb2229f3263e1e61cc.svg";
export { ForwardRef as ReactComponent };